import { type ReactNode } from 'react';
import { type TabStatus, TabStatusContext } from './TabStatusContext';

type TabStatusProviderProps = {
  children: ReactNode;
  tabStatus: TabStatus;
  refreshTabStatus: () => Promise<void>;
  isLoading: boolean;
};

export const TabStatusProvider = ({ children, tabStatus, refreshTabStatus, isLoading }: TabStatusProviderProps) => {
  return (
    <TabStatusContext.Provider value={{ tabStatus, refreshTabStatus, isLoading }}>{children}</TabStatusContext.Provider>
  );
};
